import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-prepaid-total',
  templateUrl: './prepaid-total.component.html',
  styleUrls: ['./prepaid-total.component.scss']
})
export class PrepaidTotalComponent implements OnInit {
  prepaidAmount: string;
  @Input() currencySymbol;
  slug: null;
  interval;
  public isLoadedData: boolean = false;
  constructor(private orderService: OrderService, private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
  });
  }

  ngOnInit() {
    this.getPrepaidAmount();
    if(this.slug == 'success') {
      this.interval = setInterval(() => {
          this.getPrepaidAmount();
      }, 6000);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  private getPrepaidAmount() {
    this.orderService.getPrepaidAmount().subscribe(resp => {
      if (resp.success) {
        this.prepaidAmount = resp.data.prepaid_amount;
        this.isLoadedData = true;
      }
    });
  }
}
